import IconBulletList from './IconBulletList';

export default IconBulletList;
